/* NUOMA 3.2.4 — Panier lateral complet. Shopify AJAX Cart API, sans page intermediaire. */
(() => {
  'use strict';
  const drawer = document.getElementById('CartDrawer');
  if (!drawer) return;
  const root = () => window.Shopify?.routes?.root || '/';
  const itemsEl = drawer.querySelector('[data-cart-preview]');
  const messageEl = drawer.querySelector('[data-cart-message]');
  const emptyEl = drawer.querySelector('[data-drawer-empty]');
  const footerEl = drawer.querySelector('[data-drawer-footer]');
  const countEl = drawer.querySelector('[data-drawer-head-count]');
  const totalCountEl = drawer.querySelector('[data-cart-total-count]');
  const totalPriceEl = drawer.querySelector('[data-cart-total-price]');
  const checkout = drawer.querySelector('[data-drawer-checkout]');
  let busy = false;
  let cartSnapshot = null;
  let hasCartError = false;
  let requestId = 0;

  function money(cents, currency = 'EUR') {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'fr-FR', {
        style: 'currency', currency
      }).format(Number(cents) / 100);
    } catch (_) {
      return (Number(cents) / 100).toFixed(2) + ' €';
    }
  }
  function el(tag, className, content) {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (content !== undefined) node.textContent = String(content);
    return node;
  }
  function status(text = '', error = false) {
    messageEl.textContent = text;
    messageEl.classList.toggle('is-error', error);
    messageEl.hidden = !text;
  }
  function setBusy(value) {
    busy = value;
    drawer.setAttribute('aria-busy', String(value));
    itemsEl.querySelectorAll('button, input').forEach(node => { node.disabled = value; });
    checkout.disabled = value || hasCartError || !cartSnapshot?.item_count;
  }
  function countLabel(n) {
    return n + ' article' + (n > 1 ? 's' : '');
  }
  function createItem(item, index, currency) {
    const article = el('article', 'nuoma-cart-drawer__item');
    const link = el('a', 'nuoma-cart-drawer__photo');
    link.href = item.url || root() + 'cart';
    link.setAttribute('aria-label', 'Voir ' + (item.product_title || item.title || 'le produit'));
    if (item.image) {
      const img = el('img');
      img.src = item.image;
      img.alt = item.product_title || item.title || 'Produit NUOMA';
      img.width = 92;
      img.height = 92;
      img.loading = 'lazy';
      link.append(img);
    } else {
      link.append(el('span', 'nuoma-cart-drawer__no-image', 'NUOMA'));
    }
    const content = el('div', 'nuoma-cart-drawer__item-content');
    const nameLink = el('a', 'nuoma-cart-drawer__item-name', item.product_title || item.title || 'Votre article');
    nameLink.href = item.url || root() + 'cart';
    content.append(nameLink);
    if (item.variant_title && item.variant_title !== 'Default Title') {
      content.append(el('p', 'nuoma-cart-drawer__item-variant', item.variant_title));
    }
    if (item.properties && typeof item.properties === 'object') {
      Object.entries(item.properties).forEach(([key, value]) => {
        if (key.charAt(0) !== '_' && value !== '' && value != null) {
          content.append(el('p', 'nuoma-cart-drawer__item-variant', key + ' : ' + (typeof value === 'string' ? value : String(value))));
        }
      });
    }
    const linePrice = el('p', 'nuoma-cart-drawer__item-price', money(item.final_line_price ?? item.line_price ?? (item.price * item.quantity), currency));
    content.append(linePrice);

    const actions = el('div', 'nuoma-cart-drawer__item-actions');
    const control = el('div', 'nuoma-cart-drawer__quantity');
    const minus = el('button', 'nuoma-cart-drawer__step', '−');
    minus.type = 'button';
    minus.dataset.drawerQtyStep = '-1';
    minus.dataset.line = String(index);
    minus.setAttribute('aria-label', 'Diminuer la quantité de ' + (item.product_title || item.title));
    const input = el('input', 'nuoma-cart-drawer__qty-input');
    input.type = 'number'; input.min = '1'; input.step = '1'; input.inputMode = 'numeric';
    input.value = String(item.quantity); input.dataset.drawerQtyInput = '';
    input.dataset.line = String(index);
    input.setAttribute('aria-label', 'Quantité de ' + (item.product_title || item.title));
    const plus = el('button', 'nuoma-cart-drawer__step', '+');
    plus.type = 'button';
    plus.dataset.drawerQtyStep = '1';
    plus.dataset.line = String(index);
    plus.setAttribute('aria-label', 'Augmenter la quantité de ' + (item.product_title || item.title));
    control.append(minus, input, plus);
    const remove = el('button', 'nuoma-cart-drawer__remove', 'Retirer');
    remove.type = 'button'; remove.dataset.drawerRemove = '';
    remove.dataset.line = String(index);
    remove.setAttribute('aria-label', 'Retirer ' + (item.product_title || item.title) + ' du panier');
    actions.append(control, remove);
    content.append(actions);
    article.append(link, content);
    return article;
  }

  function render(cart, options = {}) {
    if (!cart || !Array.isArray(cart.items)) return;
    cartSnapshot = cart;
    hasCartError = false;
    const currency = cart.currency || window.Shopify?.currency?.active || 'EUR';
    const fragment = document.createDocumentFragment();
    cart.items.forEach((item, i) => fragment.append(createItem(item, i + 1, currency)));
    itemsEl.replaceChildren(fragment);
    // NUOMA 3.1 : la pièce ajoutée (toujours en tête chez Shopify) apparaît en douceur.
    if (options.added) itemsEl.firstElementChild?.classList.add('is-new');
    loadUpsell(cart);
    const quantity = Number(cart.item_count) || 0;
    countEl.textContent = '(' + quantity + ')';
    totalCountEl.textContent = '· ' + countLabel(quantity);
    totalPriceEl.textContent = money(cart.total_price, currency);
    document.querySelectorAll('[data-cart-count]').forEach(node => { node.textContent = quantity; });
    emptyEl.hidden = quantity !== 0;
    footerEl.hidden = quantity === 0;
    checkout.disabled = quantity === 0 || busy;
    status(options.added ? 'Ajouté à votre panier.' : options.updated ? 'Votre panier est à jour.' : '', false);
  }

  /* NUOMA 3.1 — Suggestions complémentaires (Search & Discovery, sinon produits similaires). */
  const upsellEl = drawer.querySelector('[data-cart-upsell]');
  const upsellList = drawer.querySelector('[data-cart-upsell-list]');
  const upsellCache = new Map();
  function sized(src, width) {
    try { const url = new URL(src, location.href); url.searchParams.set('width', width); return url.toString(); } catch (_) { return src; }
  }
  function fetchRecommendations(productId, intent) {
    const key = productId + intent;
    if (!upsellCache.has(key)) {
      const url = new URL(((window.NUOMA && window.NUOMA.recommendationsUrl) || root() + 'recommendations/products') + '.json', location.origin);
      url.searchParams.set('product_id', productId);
      url.searchParams.set('limit', '4');
      url.searchParams.set('intent', intent);
      upsellCache.set(key, fetch(url, {headers: {Accept: 'application/json'}}).then(r => (r.ok ? r.json() : {products: []})).then(d => d.products || []).catch(() => []));
    }
    return upsellCache.get(key);
  }
  async function loadUpsell(cart) {
    if (!upsellEl || !upsellList) return;
    if (!cart.items.length) { upsellEl.hidden = true; return; }
    const inCart = new Set(cart.items.map(i => i.product_id));
    const first = cart.items[0];
    let products = (await fetchRecommendations(first.product_id, 'complementary')).filter(p => p.available && !inCart.has(p.id));
    if (products.length < 2) {
      (await fetchRecommendations(first.product_id, 'related')).forEach(p => { if (p.available && !inCart.has(p.id) && !products.some(x => x.id === p.id)) products.push(p); });
    }
    if (cartSnapshot !== cart) return;
    products = products.slice(0, 3);
    if (!products.length) { upsellEl.hidden = true; return; }
    upsellList.replaceChildren(...products.map(product => {
      const row = el('div', 'nuoma-upsell__item');
      const href = product.url || root() + 'products/' + product.handle;
      const media = el('a', 'nuoma-upsell__media'); media.href = href; media.tabIndex = -1;
      const src = typeof product.featured_image === 'string' ? product.featured_image : product.featured_image?.src;
      if (src) { const img = el('img'); img.src = sized(src, 200); img.alt = ''; img.loading = 'lazy'; img.width = 64; img.height = 64; media.append(img); }
      const body = el('div', 'nuoma-upsell__body');
      const name = el('a', 'nuoma-upsell__name', product.title); name.href = href;
      body.append(name, el('span', 'nuoma-upsell__price', (product.price_varies ? 'À partir de ' : '') + money(product.price_min ?? product.price)));
      row.append(media, body);
      const variants = product.variants || [];
      if (variants.length === 1 && variants[0].available) {
        const form = el('form'); form.action = root() + 'cart/add'; form.method = 'post'; form.setAttribute('data-ajax-product-form', '');
        const id = el('input'); id.type = 'hidden'; id.name = 'id'; id.value = variants[0].id;
        const qty = el('input'); qty.type = 'hidden'; qty.name = 'quantity'; qty.value = '1';
        const add = el('button', 'nuoma-upsell__add', '+'); add.type = 'submit'; add.setAttribute('aria-label', 'Ajouter ' + product.title + ' au panier');
        form.append(id, qty, add); row.append(form);
      } else {
        const choose = el('a', 'nuoma-upsell__add', '+'); choose.href = href; choose.setAttribute('aria-label', 'Choisir les options de ' + product.title);
        row.append(choose);
      }
      return row;
    }));
    upsellEl.hidden = false;
  }

  async function getCart() {
    const response = await fetch(root() + 'cart.js', { headers: {Accept: 'application/json'}, cache: 'no-store' });
    if (!response.ok) throw new Error('Impossible de charger le panier pour le moment.');
    return response.json();
  }

  async function refresh(options = {}) {
    if (busy) return;
    const myRequest = ++requestId;
    setBusy(true);
    status('Chargement de votre panier…');
    try {
      const cart = await getCart();
      if (myRequest === requestId) render(cart, options);
    } catch (error) {
      if (myRequest !== requestId) return;
      status('Impossible de charger le panier. Fermez puis rouvrez-le, ou accédez au panier classique.', true);
      const fallback = el('a', 'nuoma-cart-drawer__fallback', 'Ouvrir mon panier');
      fallback.href = root() + 'cart';
      itemsEl.replaceChildren(fallback);
      footerEl.hidden = true;
      emptyEl.hidden = true;
    } finally {
      if (myRequest === requestId) setBusy(false);
    }
  }

  async function change(line, quantity) {
    if (busy || !cartSnapshot || !Number.isInteger(line) || line < 1 || line > cartSnapshot.items.length) return;
    const currentItem = cartSnapshot.items[line - 1];
    if (!Number.isSafeInteger(quantity) || quantity < 0 || quantity > 9999) {
      status('Indiquez une quantité valide.', true);
      const field = itemsEl.querySelector(`[data-drawer-qty-input][data-line="${line}"]`);
      if (field) field.value = String(currentItem.quantity);
      return;
    }
    if (currentItem.quantity === quantity) return;
    if (quantity === 0) itemsEl.children[line - 1]?.classList.add('is-removing');
    setBusy(true);
    status('Mise à jour de votre panier…');
    try {
      const response = await fetch(root() + 'cart/change.js', {
        method: 'POST',
        headers: {'Content-Type': 'application/json', Accept: 'application/json'},
        body: JSON.stringify({line, quantity})
      });
      const result = await response.json();
      if (!response.ok || result.status) {
        throw new Error(typeof result.description === 'string' ? result.description : 'Impossible de modifier cette quantité.');
      }
      // Relire Shopify pour recouper total, prix remisés, taxes et positions des lignes.
      const authoritative = await getCart();
      render(authoritative, {updated: true});
      if (quantity > 0 && authoritative.items.find(item => item.key === currentItem.key)?.quantity !== quantity) {
        status('La quantité a été ajustée selon la disponibilité.');
      }
    } catch (error) {
      // Un POST peut avoir réussi même si la réponse a été interrompue : ne pas le rejouer.
      try {
        const actual = await getCart();
        render(actual);
        status(error.message || 'La quantité demandée n’est pas disponible.', true);
      } catch (_) {
        hasCartError = true;
        status('Connexion interrompue. Fermez puis rouvrez le panier avant de réessayer.', true);
      }
    } finally {
      setBusy(false);
    }
  }

  drawer.addEventListener('click', event => {
    const step = event.target.closest('[data-drawer-qty-step]');
    if (step) {
      event.preventDefault();
      const line = Number(step.dataset.line);
      const item = cartSnapshot?.items?.[line - 1];
      if (item) change(line, item.quantity + Number(step.dataset.drawerQtyStep));
      return;
    }
    const remove = event.target.closest('[data-drawer-remove]');
    if (remove) {
      event.preventDefault();
      change(Number(remove.dataset.line), 0);
    }
  });
  drawer.addEventListener('change', event => {
    const input = event.target.closest('[data-drawer-qty-input]');
    if (!input) return;
    const quantity = Number(input.value);
    change(Number(input.dataset.line), quantity);
  });
  drawer.addEventListener('submit', event => {
    if (!event.target.matches('[data-drawer-checkout-form]')) return;
    if (busy || !cartSnapshot?.item_count) event.preventDefault();
  });

  window.NuomaDrawerCart = {render, refresh};
})();
